module.exports = __webpack_public_path__ + "img/final.d643674a.png";